// ============================================================
// หน้า Billing — ข้อมูลการแจ้งหนี้และจัดเก็บค่าน้ำ (ออกใบแจ้งหนี้)
// ------------------------------------------------------------
// รวมบิลค้างชำระของแต่ละห้องเป็น 1 บรรทัด แล้วพิมพ์ใบแจ้งหนี้/จดหมายแจ้งเตือน
//
// วิธีรวมยอด (สำคัญ — กระทบตัวเงินโดยตรง)
//   1. ดึงบิลค้างทั้งหมดของโครงการ
//   2. applyWaived() ตัดรายการที่เก็บเงินไปแล้ว/ตัดหนี้แล้วออกให้เป็น 0
//   3. จัดกลุ่มตาม (บ้านเลขที่ + ผู้ถือกรรมสิทธิ์)
//        - งวดแรกที่เจอ (ใบล่าสุด)  → total_amount   = ยอดของงวดนั้น
//        - งวดถัดมา (ค้างเก่ากว่า)  → overdue_amount = สะสมยอดค้างเดิม
//        - รวมเป็นเงิน = total_amount + overdue_amount
//
// ⚠️ จุดที่ควรตรวจสอบ (ยกมาตามเดิม ยังไม่ได้แก้) — ดูคอมเมนต์ในส่วนปุ่มด้านล่าง
// ============================================================

import React, { Component } from "react";
import Pagination from "@mui/material/Pagination";
import Select from "react-select";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar";
import { tokens, select_style, alert, toFixed, GET, format_date, getStorage, success, calculate_water, loading, permission, getWaterSetting, BILL_FIELDS, applyWaived, unpaidAmount, addressSorter } from "../../shared/index.js";
import { report_billing } from "../../documents/builders/ReportBilling.js";
import { report_bill } from "../../documents/builders/ReportBill.js";

const perm = permission("billing");

// จำนวนแถวต่อหน้า (หน้านี้แบ่งหน้าฝั่งเบราว์เซอร์ เพราะต้องรวมยอดจากข้อมูลทั้งหมดก่อน)
const PAGE_SIZE = 10;

// นิยามช่องค่าใช้จ่าย + ตรรกะตัดรายการที่เก็บเงินแล้ว อยู่ที่ components/custom/bill-fields.js
// (ใช้ร่วมกับหน้า WaterPaymentInfo เพื่อให้รวมยอดด้วยตรรกะเดียวกัน)

// หัวคอลัมน์ที่ไม่ขึ้นกับเดือน
const STATIC_HEADERS = [
  "จำนวนหน่วยที่ใช้",
  "ค่าน้ำประปา",
  "ค่ารักษาอุปกรณ์น้ำ",
  "ค่าส่วนกลาง",
  "ค่าขยะ",
  "ค่าเคเบิล",
  "รายรับอื่นๆ",
  "เพิ่ม/ลดหนี้",
  "ค่าเบี้ยประกัน",
  "ค่าต่อกลับมิเตอร์",
  "ค่าปรับชำระล่าช้า",
  "รวม(บาท)",
  "งวด",
  "จำนวนเงินค้างชำระ",
  "รวมเป็นเงิน",
];

export default class Billing extends Component {
  constructor(props) {
    super(props);
    // รอบบิลที่แสดง = เดือนก่อนหน้า (บิลออกหลังจบเดือน)
    const current = new Date();
    current.setMonth(current.getMonth() - 1);
    const last = new Date();
    last.setMonth(last.getMonth() - 2);

    this.state = {
      page: 1,
      // ตัวกรอง
      filter_address_number: null,
      filter_building: null,
      filter_count: null,
      // ข้อมูล
      data: null, // ข้อมูลที่ผ่านตัวกรองแล้ว (ใช้แสดงตาราง)
      data_all: [], // ข้อมูลชุดเดียวกัน ใช้ตอนสั่งพิมพ์
      data_customer: [], // รายชื่อเจ้าของห้องปัจจุบัน (ใช้แยก "ลูกหนี้" ที่ไม่ใช่เจ้าของแล้ว)
      data_address: [],
      data_building: [],
      data_count: [], // ตัวเลือก "ตั้งแต่ n งวดขึ้นไป"
      // ตั้งค่าโครงการ
      penalty_day_list: [],
      penalty_month_list: [],
      payment_deadline: "",
      // ชื่อเดือนบนหัวตาราง
      date: current,
      current_month: format_date(current, "mmm"),
      last_month: format_date(last, "mmm"),
      // ตัวนับคลิกหัวข้อ — คลิกครบ 15 ครั้งจะโชว์ปุ่มลับคำนวณเบี้ยปรับรายห้อง
      count_btn: 0,
    };
  }

  async componentDidMount() {
    loading(false);
    if (!perm.view) return;
    loading(true);
    await Promise.all([this.GetAddressAll(), this.GetAll(), this.GetSetting()]);
    loading(false);
  }

  // ---------- ตรรกะการรวมยอด ----------

  // ตัวเลือกตัวกรองจำนวนงวด สร้างจากข้อมูลจริง
  generateCountFilter = (data) =>
    [...new Set(data.map((item) => item.count_installment))].sort((a, b) => a - b).map((c) => ({ value: c, label: `ตั้งแต่ ${c} งวด ขึ้นไป` }));

  // ---------- โหลดข้อมูล ----------

  GetAll = async () => {
    loading(true);
    const { filter_address_number, filter_building, filter_count } = this.state;
    const res = await GET(tokens, `v1/TH/record-receipt/filter-search/page/0/${getStorage("project_id")}`, {
      address_number: filter_address_number?.value || "",
      building: filter_building?.value || "",
    });
    if (!res?.status) {
      loading(false);
      return;
    }

    const rawData = res.data.data_water || [];
    rawData.forEach((item) => applyWaived(item));
    // เรียงใบล่าสุดขึ้นก่อน เพื่อให้ใบแรกของแต่ละกลุ่มเป็นงวดปัจจุบัน
    rawData.sort((a, b) => new Date(b.datetime_create) - new Date(a.datetime_create));

    // จัดกลุ่มตามห้อง + ผู้ถือกรรมสิทธิ์
    const groupedData = Object.values(
      rawData.reduce((acc, item) => {
        const key = `${item.address_number}_${item.ref_customer_id}`;
        const baseAmount = unpaidAmount(item);
        const itemLateFee = !item.s_late_payment ? Number(item.late_payment || 0) : 0;

        if (!acc[key]) {
          // NOTE late_payment_all = ยอดรวมเบี้ยปรับทุกงวดของห้องนี้ ใช้ "แสดงผล" ในใบแจ้งหนี้เท่านั้น
          // ไม่นำไปรวมใน total_amount/overdue_amount (late_payment ของงวดล่าสุดยังคงเดิม)
          // NOTE meter_connect_cost_all = ค่าต่อกลับมิเตอร์รวมทุกงวด ใช้ "แสดงผล" เท่านั้น (คู่กับ late_payment_all)
          //      เดิมบวกสะสมทับ meter_connect_cost ทำให้เอกสารที่โชว์ช่องนี้คู่กับยอดค้างชำระ นับมิเตอร์งวดเก่าซ้ำ
          acc[key] = { ...item, count_installment: 1, total_amount: baseAmount, overdue_amount: 0, late_payment: itemLateFee, late_payment_all: itemLateFee, meter_connect_cost_all: Number(item.meter_connect_cost || 0) };
        } else {
          acc[key].count_installment += 1;
          acc[key].overdue_amount += baseAmount;
          acc[key].meter_connect_cost_all += Number(item.meter_connect_cost || 0);
          acc[key].late_payment_all += itemLateFee;
        }
        return acc;
      }, {})
    );

    const filteredData = groupedData.filter((item) => !filter_count || Number(item.count_installment) >= Number(filter_count.value)).sort(addressSorter());

    this.setState({
      data: filteredData,
      data_all: filteredData,
      // ตัวเลือกจำนวนงวดสร้างครั้งเดียวจากข้อมูลชุดแรก
      data_count: this.state.data_count.length ? this.state.data_count : this.generateCountFilter(groupedData),
    });
    loading(false);
  };

  // ตัวเลือกอาคาร/บ้านเลขที่ + รายชื่อเจ้าของห้องปัจจุบัน
  GetAddressAll = async () => {
    const res = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`, { data_search: "", transfer_date: "", status_transfer: "" });
    if (!res?.status) return;
    const rawData = res.data.data || [];
    this.setState({
      data_address: rawData.map((item) => ({ value: item.address_number, label: item.address_number })),
      data_building: [...new Set(rawData.map((item) => item.building))].filter(Boolean).map((b) => ({ value: b, label: b })),
      data_customer: rawData.map((item) => ({ ref_customer_id: item.ref_customer_id, full_name: item.full_name, address_number: item.address_number })),
    });
  };

  GetSetting = async () => {
    const d = await getWaterSetting(getStorage("water_id"));
    if (!d) return;
    this.setState({ penalty_day_list: d.penalty_day_list, penalty_month_list: d.penalty_month_list, payment_deadline: d.payment_deadline });
  };

  // พิมพ์ใบแจ้งหนี้ของห้องเดียว — โหลดบิลทุกงวดของห้องนั้นแล้วส่งให้ตัวสร้าง PDF
  GetById = async (address_number, ref_customer_id) => {
    loading(true);
    const res = await GET(tokens, `v1/TH/record-receipt/filter-search/page/0/${getStorage("project_id")}`, { address_number });

    // กรองเฉพาะบิลของลูกค้ารายนั้น (ห้องเปลี่ยนเจ้าของมีหลายสัญญา) · ไม่มี ref_customer_id = ไม่กรอง
    const hasRef = ref_customer_id !== undefined && ref_customer_id !== null && ref_customer_id !== "";
    if (res?.status) {
      const data = res.data.data_water
        .filter((d) => !hasRef || String(d.ref_customer_id) === String(ref_customer_id))
        .map((d) => {
          // ค่าบางตัวมาเป็นข้อความมี comma ต้องแปลงเป็นตัวเลขก่อนคิด
          ["late_payment", "common_expenses", "cable_cost", "fire_cost"].forEach((k) => (d[k] = Number(String(d[k] || 0).replace(/,/g, ""))));

          applyWaived(d); // sync s_* จาก transaction_payments/writeoff_list ก่อนคิดยอด

          let total = 0;
          BILL_FIELDS.forEach(({ k, sk, m = 1 }) => {
            if (!d[sk]) total += (d[k] || 0) * m;
            else d[k] = 0;
          });
          return { ...d, total_amount: total };
        })
        .sort((a, b) => new Date(a.datetime_create) - new Date(b.datetime_create));

      report_bill(data);
    } else {
      alert("warning", "แจ้งเตือน", "ไม่มีใบแจ้งหนี้");
    }
    loading(false);
  };

  // ---------- การพิมพ์เอกสาร ----------

  // ส่งข้อมูลผ่าน localStorage แล้วเปิดหน้าเอกสารในแท็บใหม่
  openDocument = (path, data) => {
    localStorage.setItem("DATA_", JSON.stringify(data));
    window.open(path, "_blank");
  };

  // เฉพาะ "ลูกหนี้" = รายการที่ชื่อในบิลไม่ตรงกับเจ้าของห้องปัจจุบัน (เจ้าของเดิมที่ยังค้างอยู่)
  debtorRows = () => this.state.data_all.filter((e) => !this.state.data_customer.find((c) => c.address_number === e.address_number && c.full_name === e.full_name));

  // คำนวณเบี้ยปรับ/ยอดค้างใหม่
  recalculate = async (address_number) => {
    loading(true);
    if (await calculate_water(address_number)) success();
    loading(false);
  };

  render() {
    const { date, current_month, last_month, data, data_all, data_building, data_address, data_count, filter_building, filter_address_number, filter_count, page, penalty_day_list, payment_deadline } = this.state;

    // ช่องเงิน — ถ้าเก็บเงินช่องนั้นไปแล้วให้แสดง 0.00
    const val = (value, paid) => (!paid ? toFixed(value) : "0.00");

    // ปุ่มคำนวณเบี้ยปรับใหม่จะโผล่เฉพาะเจ้าของระบบ และเฉพาะช่วงวันที่เก็บเงินของรอบ
    const inPenaltyWindow = penalty_day_list?.[0] <= new Date().getDate() && new Date().getDate() <= payment_deadline;
    const canRecalculate = getStorage("user_type") === "owner" && inPenaltyWindow;

    const rows = data?.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE) || [];

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลจัดเก็บค่าใช้จ่าย" page3="ข้อมูลการแจ้งหนี้และจัดเก็บค่าน้ำ" />

        <div className="body">
          <div className="p-3">
            <div className="card border-0 p-3">
              {/* หัวข้อ — คลิกครบ 15 ครั้งจะเปิดปุ่มลับคำนวณเบี้ยปรับรายห้องในตาราง */}
              <h4 className="mb-3" onClick={() => this.setState({ count_btn: this.state.count_btn + 1 })}>
                <b>
                  ข้อมูลการแจ้งหนี้และจัดเก็บค่าน้ำ เดือน {format_date(date, "mmmm")} พ.ศ. {format_date(date, "yyyy")}
                </b>
              </h4>

              {perm.view && (
                <div className="d-flex flex-wrap justify-content-between mb-3">
                  {/* ตัวกรอง */}
                  <div className="d-flex flex-wrap align-items-center mb-2" style={{ rowGap: 8 }}>
                    <Select className="bg-contain border-0 select-search wpx-200 mx-1" styles={select_style} options={data_building} onChange={(e) => this.setState({ filter_building: e })} value={filter_building} placeholder="อาคาร" />
                    <Select className="bg-contain border-0 select-search wpx-200 mx-1" styles={select_style} options={data_address} onChange={(e) => this.setState({ filter_address_number: e })} value={filter_address_number} placeholder="บ้านเลขที่" />
                    <Select className="bg-contain border-0 select-search wpx-200 mx-1" styles={select_style} options={data_count} onChange={(e) => this.setState({ filter_count: e })} value={filter_count} placeholder="จำนวนงวด" />
                    <button className="btn btn-primary px-3 mx-1" onClick={() => this.setState({ page: 1 }, this.GetAll)}>
                      ค้นหา
                    </button>
                    <button className="btn btn-outline-primary px-3 mx-1" onClick={() => this.setState({ filter_address_number: null, filter_building: null, filter_count: null, page: 1 }, this.GetAll)}>
                      รีเซ็ท
                    </button>
                  </div>

                  {/* ปุ่มพิมพ์เอกสาร */}
                  <div className="d-flex align-items-center flex-wrap mb-2">
                    <button className="btn btn-outline-primary mx-1 px-3" onClick={() => report_billing(data_all, current_month, last_month)}>
                      พิมพ์ใบแจ้งหนี้ตามอาคาร
                    </button>
                    <button className="btn btn-outline-primary mx-1 px-3" onClick={() => this.openDocument("/doc/invoice-by-room", data_all)}>
                      พิมพ์ใบแจ้งหนี้ตามห้อง
                    </button>
                    <button className="btn btn-outline-primary mx-1 px-3" onClick={() => this.openDocument("/doc/invoice-by-room", this.debtorRows())}>
                      พิมพ์ใบแจ้งหนี้ตามห้อง (ลูกหนี้)
                    </button>
                    <button className="btn btn-outline-primary mx-1 px-3" onClick={() => this.openDocument("/doc/letter", data_all)}>
                      พิมพ์จดหมายแจ้งเตือน
                    </button>

                    {/* คำนวณเบี้ยปรับใหม่ตามตัวกรองบ้านเลขที่ที่เลือกอยู่ (ไม่เลือก = ทั้งโครงการ) */}
                    {canRecalculate && (
                      <button className="btn btn-danger mx-1 px-3" onClick={() => this.recalculate(filter_address_number?.value || "")}>
                        คำนวณเบี้ยปรับใหม่
                      </button>
                    )} 
                  </div>
                </div>
              )}

              {/* ตารางสรุปยอดรายห้อง */}
              <div className="table-responsive">
                <table className="table table-borderless table-striped text-nowrap">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      <th>บ้านเลขที่</th>
                      <th>ชื่อ-นามสกุล</th>
                      <th>เลขมาตร {current_month}</th>
                      <th>เลขมาตร {last_month}</th>
                      {STATIC_HEADERS.map((h) => (
                        <th key={h}>{h}</th>
                      ))}
                      <th className="text-center">พิมพ์ใบเสร็จ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!data?.length ? (
                      <tr>
                        <td colSpan={20} className="text-center">
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    ) : (
                      rows.map((item, index) => (
                        <tr key={index}>
                          <td>{item.address_number || "-"}</td>
                          <td>{item.full_name || "-"}</td>
                          <td>{Number(item.current_gauge_number || 0)}</td>
                          <td>{Number(item.last_gauge_number || 0)}</td>
                          <td>{Number(item.unit_used || 0)}</td>
                          <td>{val(item.water_bill, item.s_water_bill)}</td>
                          <td>{val(item.equipment_maintenance_fee, item.s_equipment_maintenance_fee)}</td>
                          <td>{val(item.common_expenses, item.s_common_expenses)}</td>
                          <td>{val(item.waste_cost, item.s_waste_cost)}</td>
                          <td>{val(item.cable_cost, item.s_cable_cost)}</td>
                          <td>{val(item.other_income, item.s_other_income)}</td>
                          {/* เพิ่ม/ลดหนี้ รวมเป็นช่องเดียว */}
                          <td>{val(item.add_debt - (item.reduce_debt || 0), item.s_add_debt)}</td>
                          <td>{val(item.fire_cost, item.s_fire_cost)}</td>
                          <td>{val(item.meter_connect_cost_all ?? item.meter_connect_cost, item.s_meter_connect_cost)}</td>
                          <td>{val(item.late_payment, item.s_late_payment)}</td>
                          <td>{toFixed(item.total_amount || 0)}</td>
                          <td>{item.count_installment || "0"}</td>
                          <td>{toFixed(item.overdue_amount || 0)}</td>
                          <td>{toFixed((item.total_amount || 0) + (item.overdue_amount || 0))}</td>
                          <td className="text-center">
                            <div className="d-flex justify-content-center">
                              {/* ปุ่มลับ (คลิกหัวข้อ 15 ครั้ง) — คำนวณเบี้ยปรับใหม่เฉพาะห้องนี้ */}
                              {this.state.count_btn > 15 && (
                                <span className="wpx-24 hpx-24 bg-dark rounded-1 d-flex align-items-center justify-content-center mr-2 m-0 pointer icon text-light" onClick={() => calculate_water(item.address_number || "")}>
                                  &#xf1ec;
                                </span>
                              )}
                              {/* ไปหน้ารับชำระของห้องนี้ */}
                              {perm.create && (
                                <span
                                  className="wpx-24 hpx-24 bg-success-light rounded-1 d-flex align-items-center justify-content-center mr-2 m-0 pointer icon text-success"
                                  onClick={() => (window.location.href = `/record-receipt?address_number=${item.address_number}`)}
                                >
                                  &#xf0d6;
                                </span>
                              )}
                              {/* พิมพ์ใบแจ้งหนี้ของห้องนี้ */}
                              <span className="wpx-24 hpx-24 bg-primary-light rounded-1 d-flex align-items-center justify-content-center m-0 pointer icon text-primary" onClick={() => this.GetById(item.address_number, item.ref_customer_id)}>
                                &#xf02f;
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* แบ่งหน้าฝั่งเบราว์เซอร์ — ข้อมูลถูกโหลดมาทั้งหมดแล้วเพื่อรวมยอด จึงไม่ต้องยิง API ซ้ำ */}
              {data?.length > 0 && (
                <div className="d-flex justify-content-between align-items-center mt-3 w-100">
                  <label>
                    แสดง {(page - 1) * PAGE_SIZE + 1} ถึง {Math.min(page * PAGE_SIZE, data.length)} รายการ จาก {data.length} รายการ
                  </label>
                  <Pagination count={Math.ceil(data.length / PAGE_SIZE)} page={page} color="primary" showFirstButton showLastButton onChange={(e, value) => this.setState({ page: value })} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
